import * as managingBrowserCookies from '~/assets/services/managingBrowserCookies/index';

managingBrowserCookies.setManagingBrowserCookie();

window.bold = {
    module: {
        managingBrowserCookies,
    },
};
